export default "__VITE_ASSET__6ge_HsPX__"